import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@mui/material";
import SegregatedMessages from "./SegregatedMessages/SegregatedMessages";
import SelectedMessages from "./SelectedMessages/SelectedMessages";
import SelectedMessage from "./SelectedMessage/SelectedMessage";
import useSnackBar from "../../Hooks/useSnackBar";
import {
  resetSwiftDay,
  getCorzapMessages,
  getBankLogoURL,
} from "../state/actions";

const SwiftDay = ({ filters }) => {
  const dispatch = useDispatch();
  const { success, error, snackbar } = useSnackBar();

  const loadMessages = useCallback(
    (filters) => dispatch(getCorzapMessages(filters, error)),
    [dispatch, error]
  );

  const loadBankLogoURL = useCallback(
    () => dispatch(getBankLogoURL(error)),
    [dispatch, error]
  );

  const reset = useCallback(() => dispatch(resetSwiftDay()), [dispatch]);

  const {
    processing,
    loadingMessages,
    currentBic,
    bankBics,
    currentMessageStatus,
    currentType,
    currentTypeMessages,
    currentMessage,
    messageDetails,
    messageTreeDetails,
    currentMessageIndex,
    messagesCount,
  } = useSelector((state) => state.swiftDay);

  useEffect(() => {
    loadBankLogoURL();
    loadMessages(filters);
    return () => reset();
  }, [reset, loadMessages, filters, loadBankLogoURL]);

  return (
    <div>
      {snackbar}
      <Grid
        container
        spacing={0}
        sx={{
          height: "calc(100vh - 178px)",
          backgroundColor: "#ffffff",
        }}
      >
        <Grid item xs={3} sx={{ height: "100%", overflowY: "auto" }}>
          <SegregatedMessages
            processing={processing}
            loadingMessages={loadingMessages}
            currentBic={currentBic}
            bankBics={bankBics}
            currentMessageStatus={currentMessageStatus}
            currentType={currentType}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sx={{ height: "100%", overflowY: "auto", overflowX: "hidden" }}
        >
          <SelectedMessages
            messages={currentTypeMessages}
            currentType={currentType}
            currentMessageStatus={currentMessageStatus}
            currentReferenceNumber={currentMessage?.header.referenceNumber}
            success={success}
            error={error}
          />
        </Grid>
        <Grid item xs={5} sx={{ height: "100%", overflowY: "auto" }}>
          <SelectedMessage
            message={currentMessage}
            messageDetails={messageDetails}
            messageIndex={currentMessageIndex}
            messagesCount={messagesCount}
            currentTypeMessages={currentTypeMessages}
            messageTreeDetails={messageTreeDetails}
            success={success}
            error={error}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default SwiftDay;
